import React, { useContext, useEffect } from "react";
import { LanguageContext } from "../../context/LanguageContext";

const AiStrategySection = () => {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);

  useEffect(() => {
    loadLanguageFile("AiStrategySection", "product/product_ai_lang");
  }, [language]);

  const LANGUAGE = componentLanguageData.AiStrategySection || { Main: {} };

  return (
    <div className="container-fluid py-5">
      <div className="container">
        <div className="row g-5 align-items-center">
          <div
            className="col-lg-6 wow fadeIn"
            data-wow-delay="0.1s"
            style={{
              visibility: "visible",
              animationDelay: "0.1s",
              animationName: "fadeIn",
            }}
          >
            <div className="ai-img">
              <img className="img-fluid" src="img/ai-img.jpg" alt="AI Strategy" />
            </div>
          </div>
          <div
            className="col-lg-6 wow fadeIn"
            data-wow-delay="0.5s"
            style={{
              visibility: "visible",
              animationDelay: "0.5s",
              animationName: "fadeIn",
            }}
          >
            <div className="btn border rounded-pill text-primary px-3 mb-3">
              {LANGUAGE.Main.Content1}
            </div>
            <h1 className="mb-4">{LANGUAGE.Main.Content2}</h1>
            <p className="mb-4">{LANGUAGE.Main.Content3}</p>
            <p className="mb-4">{LANGUAGE.Main.Content4}</p>
            <div className="row g-3">
              <div className="col-sm-6">
                <h6 className="mb-3">
                  <i className="fa fa-check text-primary me-2"></i>
                  {LANGUAGE.Main.Content5}
                </h6>
                <h6 className="mb-0">
                  <i className="fa fa-check text-primary me-2"></i>
                  {LANGUAGE.Main.Content6}
                </h6>
              </div>
              <div className="col-sm-6">
                <h6 className="mb-3">
                  <i className="fa fa-check text-primary me-2"></i>
                  {LANGUAGE.Main.Content7}
                </h6>
                <h6 className="mb-0">
                  <i className="fa fa-check text-primary me-2"></i>
                  {LANGUAGE.Main.Content8}
                </h6>
              </div>
            </div>
            <div className="d-flex align-items-center mt-4">
              <a className="btn btn-primary rounded-pill px-4 me-3" href="#ai_agent">
                {LANGUAGE.Main.Content9}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AiStrategySection;
